class DateHelpersImpl
{
    areEqual(d1: string | Date, d2: string | Date): boolean
    {
        if (!d1 && !d2) return true;
        if ((!!d1 && !d2) || (!d1 && !!d2)) return false;

        d1 = this.parseAndStripTime(d1);
        d2 = this.parseAndStripTime(d2);
        // TODO - didn't we just strip out all the time values? this is mostly like `0 === 0`?
        return d1.getTime() === d2.getTime();
    }

    private parseAndStripTime(date: string | Date): Date
    {
        const copy = new Date(typeof date === "string" ? Date.parse(date) : date);
        copy.setHours(0, 0, 0, 0);
        return copy;
    }
}

export const DateHelpers = new DateHelpersImpl();
